import SEO from "@/lib/seo.json";

/**
 * Titel, Beschreibung, Canonical und Indexierung je Seite. Die Werte stehen in
 * seo.json; dieselbe Datei nutzt scripts/seo-build.js, um beim Build für jede
 * Seite eine eigene HTML-Datei mit fertigem Kopf zu schreiben (für
 * Suchmaschinen und Linkvorschauen, die kein JavaScript ausführen). Hier wird
 * der Kopf beim Seitenwechsel im Browser nachgezogen.
 */
export const SITE_URL = SEO.siteUrl;

/** Eintrag zu einem Pfad, ohne abschließenden Schrägstrich; null, wenn unbekannt. */
export function pageMeta(pathname) {
  const path = pathname.replace(/\/+$/, "") || "/";
  return SEO.pages[path] ? { path, ...SEO.pages[path] } : null;
}

function setMeta(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }
  element.setAttribute("content", content);
}

function setCanonical(href) {
  let element = document.head.querySelector('link[rel="canonical"]');
  if (!href) {
    element?.remove();
    return;
  }
  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }
  element.setAttribute("href", href);
}

function setRobots(noindex) {
  const element = document.head.querySelector('meta[name="robots"]');
  if (noindex) setMeta("name", "robots", "noindex");
  else element?.remove();
}

/**
 * Setzt den Kopf für die aktuelle Seite. Unbekannte Pfade bekommen die
 * Angaben der 404-Seite und „noindex“.
 */
export function applySeo(pathname) {
  const meta = pageMeta(pathname);
  const { title, description } = meta ?? SEO.notFound;
  const url = meta ? `${SITE_URL}${meta.path === "/" ? "/" : meta.path}` : null;

  document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", title);
  setMeta("property", "og:description", description);
  if (url) setMeta("property", "og:url", url);
  setCanonical(meta && !meta.noindex ? url : null);
  setRobots(!meta || meta.noindex);
}
